import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { MajorTileFunction } from '../../data/functions/major_tile_fn';
import { MajorDataToggleService } from '../../data/services/major_data_toggle_service';
import { IMajorCareer, IMajorGeneralFlag } from '../../major_explorer_interface';
import { MajorProgram } from './../../data/builders/major_programs_builder';
import { MajorService } from './../../data/services/major_service';

interface IMajorDetailViewModel {
  careers?: IMajorCareer[];
  loadingMessage: string;
  banner: string;
}

export class MajorDetailViewContentController {
  private major: MajorProgram;
  private flags: IMajorGeneralFlag;
  private model: IMajorDetailViewModel;

  constructor(
    private $state: ng.ui.IStateService,
    private majorTileFn: MajorTileFunction,
    private majorDataToggleService: MajorDataToggleService,
    private ngMajorService: MajorService,
    private loadRelatedCareersCommand: ICommand
  ) {}

  $onInit(): void {
    this.model = {
      careers: undefined,
      loadingMessage: 'Loading related careers...',
      banner: this.ngMajorService.isCurrentMajor(this.major.id) ? 'Current Major' : ''
    };

    this.flags = {
      hasMeaningfulInterests: !_4.isEmpty(_4.compact(this.major._interests)),
      showSalary: this.majorDataToggleService.toggles.salary,
      showJobDemand: this.majorDataToggleService.toggles.hiringDemand,
      showTuition: this.majorDataToggleService.toggles.tution,
      showDevCourses: this.majorDataToggleService.toggles.devCourses,
      showCourseMaps: this.majorDataToggleService.toggles.courseMaps,
      showCredits: this.majorDataToggleService.toggles.credits,
      showCredentials: !_4.isEmpty(this.major.short_credential)
    };

    this.loadRelatedCareersCommand(this.major.id).then((careerResults) => {
      this.majorTileFn.buildCareers(careerResults);
      this.model.loadingMessage = '';
      this.model.careers = careerResults;
    });
  }

  get majorSalary(): string {
    return this.ngMajorService.getMajorSalaryString(this.major);
  }

  goToCourseMap(): void {
    this.$state.go('my.coursemap', {
      id: this.major.id,
      selectedMajor: this.major
    });
  }

  hasInterests(): boolean {
    return !!this.flags.hasMeaningfulInterests && !_4.isEmpty(this.major._interests);
  }
}

export class MajorDetailViewContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/major_detail_view_content/major_detail_view_content.html';
  public controller: any = MajorDetailViewContentController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    major: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_detail_view_content/major_detail_view_content_controller.ts